import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../Components/baseUrl";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../../Components/apiErrorHelpers.js";
import InfiniteScroll from "react-infinite-scroll-component";
import GiftModal from "../../Components/GiftModal";
import DescriptionModal from "../../Components/DescriptionModal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Gallery from "../../Components/Gallery";
import { translation } from "../../Components/Translation";
import ProductUnitSelect from "../../Components/ProductUnitSelect";
import ProductQuantityInput from "../../Components/ProductQuantityInput";
import ProductUnitPriceInput from "../../Components/ProductUnitPriceInput";
import LinePriceEditIntroModal, {
  isLinePriceEditIntroDismissed,
} from "../../Components/LinePriceEditIntroModal";
import ProductSortModal from "../../Components/ProductSortModal";
import AppIcon from "../../Components/AppIcon";
import {
  mapProductFromApi,
  changeProductUnit,
  increaseProductCount,
  decreaseProductCount,
  setProductCount,
  setProductUnitPrice,
  buildOrderItems,
  getUnitOptions,
  formatCustomerProfitPercent,
  resetProductCartCounts,
} from "../../Components/productUnitHelpers";
import {
  canChangeLinePrice,
  fetchPermissions,
  getPermissionsSnapshot,
} from "../../Components/userPermissions";
import {
  getVisitorReferenceCache,
  ensureVisitorReferenceCache,
} from "../../Components/visitorReferenceCache";
import {
  readShopProductsPrefetch,
  writeShopProductsPrefetch,
} from "../../Components/shopProductsPrefetch";
import {
  getProductCardClassName,
} from "../../Components/productExpiryHelpers";
import {
  buildProductListPayload,
  orderProductListForDisplay,
  hasActiveProductSort,
  hasActiveProductFilter,
  resolveProductListHasMore,
  shouldFillProductListViewport,
} from "../../Components/productListQueryHelpers";
import {
  loadDraftCart,
  mergeDraftIntoProducts,
  applyShopCartUpdate,
  resolveOrderTotal,
  clearDraftCart,
  saveDraftCart,
} from "../../Components/productCartStorage";
import { createSearchEnterHandler } from "../../Components/searchInputHelpers";
import {
  CartBarSkeleton,
  LoadMoreSkeleton,
  ProductListSkeleton,
} from "../../Components/SkeletonLoading";
import CreditPaymentBlockModal from "../../Components/CreditPaymentBlockModal";
import CreditCartPreviewBar from "../../Components/CreditCartPreviewBar";
import {
  extractCreditBlockFromError,
  fetchCreditPaymentBlockStatus,
  navigateToCreditPayment,
  applyCreditBlockFromStatus,
} from "../../Components/creditPaymentBlock";

const ShopProducts = () => {
  const navigate = useNavigate();
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fa");
  let token;
  let user;
  let currency;
  if (typeof window !== "undefined") {
    token = localStorage.getItem("token");
    user = localStorage.getItem("user");
    currency = localStorage.getItem("currency");
  }
  useEffect(() => {
    document.title = "ویزیت | محصولات";
    token == null && navigate("/login", { replace: true });
  }, []);
  const { shopId } = useParams();
  const [showFilter, setShowFilter] = useState(false);
  const [showProductSort, setShowProductSort] = useState(false);
  const [productSort, setProductSort] = useState("");
  const [priceFrom, setPriceFrom] = useState("");
  const [priceTo, setPriceTo] = useState("");
  const [activeMenu, setActiveMenu] = useState(0);
  const [productList, setProductList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const paginateRef = useRef(null);
  const loadingMoreRef = useRef(false);
  const productRequestRef = useRef(0);
  const productQueryRef = useRef({});
  const [cartLoading, setCartLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [catList, setCatList] = useState([]);
  const [shopCatList, setShopCatList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [selectedCat, setSelectedCat] = useState("");
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [subCat, setSubCat] = useState(null)
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [subcategoryList, setSubcategoryList] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [warehouseList, setWarehouseList] = useState([]);
  const [canEditLinePrice, setCanEditLinePrice] = useState(canChangeLinePrice());
  const [showLinePriceIntro, setShowLinePriceIntro] = useState(false);
  const [pendingPriceProductId, setPendingPriceProductId] = useState(null);
  const [focusPriceProductId, setFocusPriceProductId] = useState(null);
  const [showInventory, setShowInventory] = useState(false);
  const [creditBlock, setCreditBlock] = useState(null);

  const showCreditBlockModal = (status) => {
    const block = applyCreditBlockFromStatus(status, shopId);
    if (!block) {
      return false;
    }

    setCreditBlock(block);
    return true;
  };

  useEffect(() => {
    const timer = window.setTimeout(() => {
      fetchCreditPaymentBlockStatus(shopId)
        .then((status) => showCreditBlockModal(status))
        .catch(() => {});
    }, 800);

    return () => window.clearTimeout(timer);
  }, [shopId]);

  useEffect(() => {
    const cachedPermissions = getPermissionsSnapshot();
    if (cachedPermissions) {
      setCanEditLinePrice(cachedPermissions.can_change_line_price === true);
      return;
    }

    fetchPermissions(axios, baseUrl).then((permissions) => {
      setCanEditLinePrice(permissions?.can_change_line_price === true);
    });
  }, []);

  const applyReferenceCache = (cache) => {
    if (!cache) {
      return;
    }

    setCatList(cache.categories || []);
    setShopCatList(cache.companyCategories || []);
    setWarehouseList(cache.warehouses || []);
  };

  useEffect(() => {
    applyReferenceCache(getVisitorReferenceCache());

    ensureVisitorReferenceCache(axios, baseUrl)
      .then((cache) => applyReferenceCache(cache))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!focusPriceProductId) {
      return undefined;
    }

    const timer = setTimeout(() => setFocusPriceProductId(null), 150);
    return () => clearTimeout(timer);
  }, [focusPriceProductId]);

  const brandHandler = (id) => {
    setSelectedCat(id);
    setSelectedSubcategory(null);
    Promise.all([
      axios({
        url: `${baseUrl}/brands?category_id=${id}`,
        method: "GET",
      }),
      axios({
        url: `${baseUrl}/subcategories?category_id=${id}`,
        method: "GET",
      }),
    ])
      .then(([brandsRes, subsRes]) => {
        setBrandList(brandsRes.data.data || []);
        const subs = subsRes.data.data || [];
        setSubcategoryList(subs);
        setShowFilterTab(subs.length > 0 ? 4 : 2);
      })
      .catch((err) => {
        setCartLoading(false);
        showApiErrorToast(toast, err);
      });
  };
  const [loading, setLoading] = useState(true);

  const getProductQueryParams = () => ({
    searchText,
    filter: 1,
    selectedCat,
    selectedBrand,
    subCat,
    selectedSubcategory,
    selectedWarehouse,
    onlyAvailable: showInventory,
    productSort,
    priceFrom,
    priceTo,
  });

  useEffect(() => {
    productQueryRef.current = getProductQueryParams();
  }, [
    searchText,
    selectedCat,
    selectedBrand,
    subCat,
    selectedSubcategory,
    selectedWarehouse,
    showInventory,
    productSort,
    priceFrom,
    priceTo,
  ]);

  const syncProductPaginate = (paginate, loadedCount) => {
    paginateRef.current = paginate || null;
    setHasMore(resolveProductListHasMore(paginate, loadedCount));
  };

  const handleProductSortApply = ({ sort, priceFrom: nextFrom, priceTo: nextTo }) => {
    const nextSort = sort || "";
    const nextPriceFrom = nextFrom || "";
    const nextPriceTo = nextTo || "";
    setProductSort(nextSort);
    setPriceFrom(nextPriceFrom);
    setPriceTo(nextPriceTo);
    setShowProductSort(false);
    setHasMore(true);
    setLoading(true);
    productHandler({
      sort: nextSort,
      priceFrom: nextPriceFrom,
      priceTo: nextPriceTo,
    });
  };

  const applyProductResponse = (payload, activeSort, requestId) => {
    if (requestId !== productRequestRef.current || !payload) {
      return;
    }

    setLoading(false);
    setShowConfirm(false);
    setShowFilter(false);
    setShowProductSort(false);
    setCartLoading(false);

    const baseTotal = payload?.new_order_total ?? 0;
    setBaseNewOrderTotal(baseTotal);
    const rawProducts = payload?.products;

    if (Array.isArray(rawProducts) && rawProducts.length > 0) {
      let products = rawProducts.map((item) => mapProductFromApi(item));
      products = mergeDraftIntoProducts(products, loadDraftCart(shopId));
      const sortedProducts = orderProductListForDisplay(products, activeSort);
      setProductList(sortedProducts);
      setAllAmount(resolveOrderTotal(baseTotal, sortedProducts));
      syncProductPaginate(payload?.paginate, sortedProducts.length);
      return;
    }

    setProductList([]);
    setAllAmount(resolveOrderTotal(baseTotal, []));
    paginateRef.current = null;
    setHasMore(false);
  };

  const isInitialProductQuery = (overrides = {}) =>
    !overrides.sort &&
    !overrides.priceFrom &&
    !overrides.priceTo &&
    !searchText &&
    !selectedCat &&
    !selectedBrand &&
    !subCat &&
    !selectedSubcategory &&
    !selectedWarehouse &&
    !showInventory &&
    !productSort &&
    !priceFrom &&
    !priceTo;

  const productHandler = (overrides = {}) => {
    const preserveList = overrides.preserveList === true;
    const requestId = ++productRequestRef.current;
    loadingMoreRef.current = false;
    if (!preserveList) {
      paginateRef.current = null;
      setProductList([]);
    }
    const activeSort = overrides.sort ?? productSort;
    const data = buildProductListPayload({
      ...getProductQueryParams(),
      productSort: activeSort,
      priceFrom: overrides.priceFrom ?? priceFrom,
      priceTo: overrides.priceTo ?? priceTo,
    });

    if (!preserveList && isInitialProductQuery(overrides)) {
      const prefetched = readShopProductsPrefetch(shopId);
      if (prefetched?.data) {
        applyProductResponse(prefetched.data, activeSort, requestId);
      }
    }

    axios({
      url: `${baseUrl}/shops/${shopId}/products?page=1&count=20`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((res) => {
        if (isInitialProductQuery(overrides)) {
          writeShopProductsPrefetch(shopId, res.data);
        }
        applyProductResponse(res?.data?.data, activeSort, requestId);
      })
      .catch((err) => {
        if (requestId !== productRequestRef.current) {
          return;
        }
        setLoading(false);
        setShowConfirm(false);
        setShowFilter(false);
        setCartLoading(false);
        showApiErrorToast(toast, err);
      });
  };
  useEffect(() => {
    if (!shopId) {
      return;
    }
    setLoading(true);
    productHandler();
  }, [shopId]);
  const [baseNewOrderTotal, setBaseNewOrderTotal] = useState(0);
  const [allAmount, setAllAmount] = useState(0);

  const handleProductSearch = () => {
    if (allAmount !== 0) {
      setShowConfirm(true);
      return;
    }

    productHandler();
  };

  const updateCart = (nextList) => {
    setProductList(nextList);
    setAllAmount(applyShopCartUpdate(shopId, nextList, baseNewOrderTotal));
  };

  const showLimitToast = () => {
    toast.error(
      translation.Products_number[lang]
        ? translation.Products_number[lang]
        : "تعداد سفارشات بیش از حد مجاز",
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
  };

  const increaseHandler = (item) => {
    const { productList: nextList, limitHit } = increaseProductCount(productList, item.id);
    if (limitHit) {
      showLimitToast();
      return;
    }
    updateCart(nextList);
  };
  const decreaseHandler = (item) => {
    updateCart(decreaseProductCount(productList, item.id));
  };
  const countChangeHandler = (item, nextCount) => {
    const { productList: nextList, limitHit } = setProductCount(
      productList,
      item.id,
      nextCount
    );
    if (limitHit) {
      showLimitToast();
    }
    updateCart(nextList);
  };
  const unitChangeHandler = (item, unitLevel) => {
    updateCart(changeProductUnit(productList, item.id, unitLevel));
  };
  const priceChangeHandler = (item, nextPrice) => {
    updateCart(setProductUnitPrice(productList, item.id, nextPrice));
  };
  const handlePriceFocusAttempt = (productId) => {
    if (!canEditLinePrice) {
      return false;
    }
    if (isLinePriceEditIntroDismissed()) {
      return true;
    }
    setPendingPriceProductId(productId);
    setShowLinePriceIntro(true);
    return false;
  };
  const handleLinePriceIntroConfirm = () => {
    setShowLinePriceIntro(false);
    if (pendingPriceProductId) {
      setFocusPriceProductId(pendingPriceProductId);
    }
    setPendingPriceProductId(null);
  };
  const [showConfirm, setShowConfirm] = useState(false);
  const addToCartHandler = async (e) => {
    setShowConfirm(false);
    setCartLoading(true);

    try {
      const status = await fetchCreditPaymentBlockStatus(shopId);
      if (showCreditBlockModal(status)) {
        setCartLoading(false);
        return;
      }
    } catch (_) {
      // ادامه ثبت سفارش در صورت خطای بررسی اعتبار
    }

    let items = buildOrderItems(productList, shopId);
    let data = {
      orders: items,
    };
    let config = {
      url: `${baseUrl}/orders`,
      method: "POST",
      data: data,
    };
    axios(config)
      .then((resp) => {
        const createdOrderId = resp?.data?.data?.order_id;
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            let data = new FormData();
            data.append("lat", latitude);
            data.append("lng", longitude);
            let config = {
              method: "POST",
              url: `${baseUrl}/location`,
              data: data,
            };
            axios(config)
              .then((response) => { })
              .catch(function (err) { });
          },
          (error) => {
            console.error("Error getting user location:", error.message);
          }
        );
        let config2 = {
          url: `${baseUrl}/orders/${resp.data.data.order_id}/confirm-cancel?status=confirm`,
          method: "GET",
        };
        resp.data &&
          resp.data.data &&
          axios(config2)
            .then((res) => {
              clearDraftCart(shopId);
              setCartLoading(false);
              setSearchText("");
              const clearedList = resetProductCartCounts(productList);
              setProductList(clearedList);
              setBaseNewOrderTotal(0);
              setAllAmount(resolveOrderTotal(0, clearedList));
              productHandler({ preserveList: true });
              res &&
                res.data &&
                res.data.message &&
                toast.success(
                  translation.Products_Successfully[lang]
                    ? translation.Products_Successfully[
                    lang
                    ]
                    : "با موفقیت به سبد خرید اضافه شد",

                  {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  }
                );
            })
            .catch((err) => {
              setCartLoading(false);
              if (createdOrderId) {
                clearDraftCart(shopId);
                const clearedList = resetProductCartCounts(productList);
                setProductList(clearedList);
                setBaseNewOrderTotal(0);
                setAllAmount(resolveOrderTotal(0, clearedList));
                toast.warning(
                  "سفارش ثبت شد اما تایید نهایی انجام نشد. از صفحه فاکتور پیگیری کنید.",
                  { position: "top-center", autoClose: 6000 }
                );
                navigate(`/panel/factor/${createdOrderId}`);
                return;
              }
              showApiErrorToast(toast, err);
            });
      })
      .catch((err) => {
        setCartLoading(false);
        const block = extractCreditBlockFromError(err);
        if (block) {
          setCreditBlock({ ...block, customerId: shopId });
          return;
        }
        err.response &&
          err.response.data &&
          showApiErrorToast(toast, err);
      });
  };

  const loadMoreProducts = useCallback(() => {
    const paginate = paginateRef.current;
    if (!paginate?.nextPage || loadingMoreRef.current) {
      return;
    }

    loadingMoreRef.current = true;
    const data = buildProductListPayload(productQueryRef.current);
    const config = {
      url: `${baseUrl}/shops/${shopId}/products?page=${paginate.nextPage}&count=20`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data,
    };

    axios(config)
      .then(async (res) => {
        const rawProducts = res?.data?.data?.products;
        if (!rawProducts?.length) {
          setProductList((prevData) => {
            syncProductPaginate(res?.data?.data?.paginate, prevData.length);
            return prevData;
          });
          return;
        }

        let newProducts = rawProducts.map((item) => mapProductFromApi(item));

        setProductList((prevData) => {
          const draft = loadDraftCart(shopId);
          const existingIds = new Set(prevData.map((product) => product.id));
          const uniqueProducts = newProducts.filter(
            (product) => !existingIds.has(product.id)
          );
          const mergedProducts = mergeDraftIntoProducts(uniqueProducts, draft);
          const nextList = orderProductListForDisplay(
            [...prevData, ...mergedProducts],
            productQueryRef.current.productSort
          );
          setAllAmount(resolveOrderTotal(baseNewOrderTotal, nextList));
          saveDraftCart(shopId, nextList);
          syncProductPaginate(res?.data?.data?.paginate, nextList.length);
          return nextList;
        });
      })
      .catch((err) => {
        showApiErrorToast(toast, err, "خطا در دریافت کالاها");
      })
      .finally(() => {
        loadingMoreRef.current = false;
      });
  }, [shopId, baseNewOrderTotal]);

  useEffect(() => {
    if (
      !loading &&
      hasMore &&
      productList.length > 0 &&
      shouldFillProductListViewport(hasMore)
    ) {
      loadMoreProducts();
    }
  }, [loading, hasMore, productList.length, loadMoreProducts]);

  // Filter
  const [showFilterTab, setShowFilterTab] = useState(0);
  const [gift, setGift] = useState([]);
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [description, setDescription] = useState([]);
  const [showDescription, setShowDescription] = useState(false);

  // Gallery
  const [showGallery, setShowGallery] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);

  const openGallery = (images) => {
    setGalleryImages(images);
    setShowGallery(true);
  };

  const closeGallery = () => {
    setShowGallery(false);
  };

  return (
    <div className="container">
      {showGiftModal && <GiftModal gift={gift} />}
      {showDescription && <DescriptionModal description={description} />}
      {showGallery && (
        <Gallery images={galleryImages} onClose={closeGallery} />
      )}
      {showLinePriceIntro && (
        <LinePriceEditIntroModal
          onConfirm={handleLinePriceIntroConfirm}
          onClose={() => {
            setShowLinePriceIntro(false);
            setPendingPriceProductId(null);
          }}
        />
      )}
      <CreditPaymentBlockModal
        visible={!!creditBlock}
        mode={creditBlock?.type === "expired" ? "expired" : "payment"}
        message={creditBlock?.message}
        count={creditBlock?.count || 0}
        orders={creditBlock?.orders || []}
        onConfirm={() => {
          if (!creditBlock?.orders?.length) {
            setCreditBlock(null);
            return;
          }
          navigateToCreditPayment(
            navigate,
            creditBlock.orders[0].id,
            creditBlock.customerId,
            "/"
          );
          setCreditBlock(null);
        }}
        onDismiss={() => setCreditBlock(null)}
      />
      {showConfirm && (
        <div className="logout-modal">
          <h2>خروج</h2>
          <span className="ques">
            آیا مایلید سفارش فعلی خود را ذخیره کنید؟
          </span>
          <div className="btns">
            <button
              onClick={() => {
                addToCartHandler();
              }}
              className="stay"
            >
              ذخیره
            </button>
            <button
              onClick={() => setShowConfirm(false)}
              className="exit"
            >
              {translation.New_orders_Cancel[lang]
                ? translation.New_orders_Cancel[lang]
                : "لغو"}
            </button>
          </div>
        </div>
      )}
      {loading ? (
        <ProductListSkeleton />
      ) : productList && productList.length !== 0 ? (
        <div className="product-main">
          {(activeMenu !== 0 ||
            showFilter ||
            showProductSort ||
            showGiftModal ||
            showDescription) && (
              <div
                onClick={() => {
                  setActiveMenu(0);
                  setShowFilter(false);
                  setShowProductSort(false);
                  setShowGiftModal(false);
                  setShowDescription(false);
                }}
                id="bg_gray"
                className="bg-gray"
              ></div>
          )}
          {showProductSort && (
            <ProductSortModal
              activeSort={productSort}
              priceFrom={priceFrom}
              priceTo={priceTo}
              onApply={handleProductSortApply}
              onClose={() => setShowProductSort(false)}
            />
          )}
          {showFilter && (
            <div id="filter_modal" className="filter-modal">
              <div className="filter-modal-head">
                {/* <svg
                                    onClick={productHandler}
                                    className="orang-filter"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56"
                                        stroke="#FF0000"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M21.89 12C21.89 17.52 17.41 22 11.89 22C6.37 22 3 16.44 3 16.44M3 16.44H7.52M3 16.44V21.44"
                                        stroke="#FF0000"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg> */}
              </div>
              <h2>
                <svg
                  onClick={() => {
                    setShowFilter(false);
                    allAmount !== 0
                      ? setShowConfirm(true)
                      : productHandler();
                  }}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 7L11 7"
                    stroke="#3BA7E4"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                    stroke="#3BA7E4"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M3 17L13 17"
                    stroke="#3BA7E4"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                    stroke="#3BA7E4"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
                {translation.Products_filter[lang]
                  ? translation.Products_filter[lang]
                  : "فیلتر"}
              </h2>
              <button
                id="show_invent_btn"
                onClick={() => setShowInventory(!showInventory)}
                className={
                  showInventory
                    ? "inventory-tbn to-center-btn"
                    : "inventory-tbn "
                }
              >
                <span className="btn-in">
                  <svg
                    width="7"
                    height="7"
                    viewBox="0 0 7 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="3.5"
                      cy="3.5"
                      r="3.5"
                      fill="#979797"
                    />
                  </svg>
                  {translation.Products_available[lang]
                    ? translation.Products_available[lang]
                    : "فقط کالا های موجود"}
                </span>
              </button>
              <button
                onClick={() => {
                  showFilterTab !== 1
                    ? setShowFilterTab(1)
                    : setShowFilterTab(0);
                }}
                className="filter-btn"
              >
                {translation.Products_Select[lang]
                  ? translation.Products_Select[lang]
                  : "انتخاب دسته بندی"}
                <svg
                  width="14"
                  height="11"
                  viewBox="0 0 14 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
                    fill="#8C8C8C"
                  />
                </svg>
              </button>
              <div
                id="filter_tab_1"
                className={
                  showFilterTab !== 1
                    ? "filter-items"
                    : "filter-items show"
                }
              >
                {catList &&
                  catList.length !== 0 &&
                  catList.map((item) => {
                    return (
                      <button
                        onClick={() =>
                          brandHandler(item.id)
                        }
                        key={item.id}
                        className={
                          item.id == selectedCat &&
                          "bg-info"
                        }
                      >
                        {item.title}
                      </button>
                    );
                  })}
              </div>
              <button
                onClick={() => {
                  showFilterTab !== 4
                    ? setShowFilterTab(4)
                    : setShowFilterTab(0);
                }}
                className="filter-btn"
                disabled={!selectedCat}
              >
                {translation.Products_Subcategory?.[lang] || "انتخاب زیر دسته"}
                <svg
                  width="14"
                  height="11"
                  viewBox="0 0 14 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
                    fill="#8C8C8C"
                  />
                </svg>
              </button>
              <div
                id="filter_tab_4"
                className={
                  showFilterTab !== 4
                    ? "filter-items"
                    : "filter-items show"
                }
              >
                {subcategoryList.length === 0 ? (
                  <span className="filter-empty-hint">
                    {selectedCat
                      ? "زیردسته‌ای برای این دسته یافت نشد"
                      : "ابتدا دسته‌بندی اصلی را انتخاب کنید"}
                  </span>
                ) : (
                  subcategoryList.map((item) => (
                    <button
                      onClick={() => setSelectedSubcategory(item.id)}
                      key={item.id}
                      className={
                        item.id == selectedSubcategory && "bg-info"
                      }
                    >
                      {item.title}
                    </button>
                  ))
                )}
              </div>
              <button
                onClick={() => {
                  showFilterTab !== 2
                    ? setShowFilterTab(2)
                    : setShowFilterTab(0);
                }}
                className="filter-btn"
              >
                {translation.Products_Brand[lang]
                  ? translation.Products_Brand[lang]
                  : "انتخاب برند"}
                <svg
                  width="14"
                  height="11"
                  viewBox="0 0 14 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
                    fill="#8C8C8C"
                  />
                </svg>
              </button>
              <div
                id="filter_tab_2"
                className={
                  showFilterTab !== 2
                    ? "filter-items"
                    : "filter-items show"
                }
              >
                {brandList &&
                  brandList.length !== 0 &&
                  brandList.map((item) => {
                    return (
                      <button
                        className={
                          item.id == selectedBrand &&
                          "bg-info"
                        }
                        onClick={() =>
                          setSelectedBrand(item.id)
                        }
                        key={item.id}
                      >
                        {item.name}
                      </button>
                    );
                  })}
              </div>
              <button
                onClick={() => {
                  showFilterTab !== 3
                    ? setShowFilterTab(3)
                    : setShowFilterTab(0);
                }}
                className="filter-btn"
              >
                {translation.Products_Internal[lang]
                  ? translation.Products_Internal[lang]
                  : "انتخاب دسته بندی داخلی"}
                <svg
                  width="14"
                  height="11"
                  viewBox="0 0 14 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
                    fill="#8C8C8C"
                  />
                </svg>
              </button>
              <div
                id="filter_tab_3"
                className={
                  showFilterTab !== 3
                    ? "filter-items"
                    : "filter-items show"
                }
              >
                {shopCatList &&
                  shopCatList.length !== 0 &&
                  shopCatList.map((item) => {
                    return (
                      <button
                        onClick={() =>
                          setSubCat(item.id)
                        }
                        key={item.id}
                        className={
                          item.id == subCat &&
                          "bg-info"
                        }
                      >
                        {item.title}
                      </button>
                    );
                  })}
              </div>
              <button
                onClick={() => {
                  showFilterTab !== 5
                    ? setShowFilterTab(5)
                    : setShowFilterTab(0);
                }}
                className="filter-btn"
              >
                {translation.Products_Warehouse?.[lang] || "انتخاب انبار"}
                <svg
                  width="14"
                  height="11"
                  viewBox="0 0 14 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z"
                    fill="#8C8C8C"
                  />
                </svg>
              </button>
              <div
                id="filter_tab_5"
                className={
                  showFilterTab !== 5
                    ? "filter-items"
                    : "filter-items show"
                }
              >
                {warehouseList.length === 0 ? (
                  <span className="filter-empty-hint">
                    انباری برای ویزیتور تعریف نشده
                  </span>
                ) : (
                  warehouseList.map((item) => (
                    <button
                      onClick={() => setSelectedWarehouse(item.id)}
                      key={item.id}
                      className={
                        item.id == selectedWarehouse && "bg-info"
                      }
                    >
                      {item.name}
                    </button>
                  ))
                )}
              </div>
              <button className="py-2 px-4 mt-3 filter-btn-2"
                onClick={() => {
                  setHasMore(true);
                  setLoading(true);
                  if (allAmount !== 0) {
                    setShowConfirm(true);
                    return;
                  }
                  productHandler();
                }}
              >
                اعمال فیلتر
              </button>
            </div>
          )}
          <div className="search-box" id="search_box">
            <div className="pos-rel-search">
              <input
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={createSearchEnterHandler(handleProductSearch)}
                type="text"
                value={searchText}
                placeholder={
                  translation.toast_error003[lang]
                    ? translation.toast_error003[lang]
                    : "جستجو کنید"
                }
              />
              <svg
                onClick={handleProductSearch}
                className="search-svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                  stroke="#A2A2A2"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16.5 16.958L21.5 21.958"
                  stroke="#A2A2A2"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div
              className={`svg-rec ${hasActiveProductSort({ productSort, priceFrom, priceTo }) ? "svg-rec-active-sort" : ""}`}
              onClick={() => setShowProductSort(true)}
            >
              <AppIcon name="sort" width={24} height={24} alt="مرتب‌سازی" />
            </div>

            <div
              className={`svg-rec ${
                hasActiveProductFilter({
                  selectedCat,
                  selectedBrand,
                  subCat,
                  selectedSubcategory,
                  selectedWarehouse,
                  onlyAvailable: showInventory,
                })
                  ? "svg-rec-active-filter"
                  : ""
              }`}
              onClick={() => setShowFilter(true)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 7L11 7"
                  stroke="#A2A2A2"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                  stroke="#A2A2A2"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M3 17L13 17"
                  stroke="#A2A2A2"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                  stroke="#A2A2A2"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
          <div className="product-alert">
            <div className="d-flex-center color-b">
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.92705 20.373C6.72288 22.7501 8.60412 24.7918 10.9958 24.7918H26.5271C28.6271 24.7918 30.4645 23.071 30.625 20.9855L31.4125 10.048C31.5875 7.62721 29.75 5.65845 27.3145 5.65845H8.48747"
                  stroke="#0085FF"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.91663 2.91675H5.45413C7.02913 2.91675 8.26871 4.273 8.13746 5.83341L7.4083 14.6563"
                  stroke="#0085FF"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M23.6979 32.0833C24.7047 32.0833 25.5208 31.2672 25.5208 30.2604C25.5208 29.2536 24.7047 28.4375 23.6979 28.4375C22.6911 28.4375 21.875 29.2536 21.875 30.2604C21.875 31.2672 22.6911 32.0833 23.6979 32.0833Z"
                  stroke="#0085FF"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.0313 32.0833C13.0381 32.0833 13.8542 31.2672 13.8542 30.2604C13.8542 29.2536 13.0381 28.4375 12.0313 28.4375C11.0245 28.4375 10.2084 29.2536 10.2084 30.2604C10.2084 31.2672 11.0245 32.0833 12.0313 32.0833Z"
                  stroke="#0085FF"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.125 11.6667H30.625"
                  stroke="#0085FF"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span>
              {allAmount.toLocaleString()} {currency && currency}{" "}
            </span>
          </div>
          <InfiniteScroll
            dataLength={productList.length}
            next={loadMoreProducts}
            hasMore={hasMore}
            loader={
              productList.length !== 0 && <LoadMoreSkeleton variant="product" />
            }
          >
            {productList !== undefined &&
              productList !== null &&
              productList.length !== 0 &&
              productList.map((item) => {
                const unitOptions = getUnitOptions(item);
                return (
                  <div key={item.id} className={getProductCardClassName(item)}>
                    <div className="row-1">
                      <div className="img-div">
                        {item.Images &&
                          item.Images[0] ? (
                          <div
                            className="img-div"
                            onClick={() =>
                              openGallery(
                                item.Images
                              )
                            }
                          >
                            <img
                              src={
                                item.Images[0]
                                  .image
                              }
                              alt=""
                            />
                          </div>
                        ) : (
                          <div className="img-div">
                            <img
                              src={item.Images}
                              alt=""
                            />
                          </div>
                        )}
                      </div>
                      <div>
                        <div className="marquee">
                          <h4
                            className={
                              item.name.length <
                                13
                                ? "name"
                                : item.name
                                  .length <
                                  25
                                  ? "name moving-2"
                                  : "name moving"
                            }
                          >
                            <span>{item.name}</span>
                          </h4>
                        </div>
                        <div className="d-flex-center product-highlight-row product-unit-price-row">
                          <span className="price-span-1">
                            {translation
                              .Products_Unit[lang]
                              ? translation
                                .Products_Unit[
                              lang
                              ]
                              : "قیمت واحد"}
                            :
                          </span>
                          {canEditLinePrice ? (
                            <>
                              <ProductUnitPriceInput
                                value={item.unit_price}
                                autoFocus={focusPriceProductId === item.id}
                                onFocusAttempt={() =>
                                  handlePriceFocusAttempt(item.id)
                                }
                                onCommit={(nextPrice) =>
                                  priceChangeHandler(item, nextPrice)
                                }
                              />
                              <span className="product-unit-price-currency">
                                {currency && currency}
                              </span>
                            </>
                          ) : (
                            <span className="price-span-2">
                              {Number(
                                item.unit_price
                              ).toLocaleString()}{" "}
                              {currency && currency}
                            </span>
                          )}
                        </div>
                        <div className="d-flex-center product-highlight-row">
                          <span className="muted-span-1">
                            {translation
                              .Products_Store[
                              lang
                            ]
                              ? translation
                                .Products_Store[
                              lang
                              ]
                              : "قیمت فروشگاه"}
                            :
                          </span>
                          <span className="muted-span-2 product-highlight-value">
                            {Number(
                              item.store_price
                            ).toLocaleString()}{" "}
                            {currency && currency}
                          </span>
                        </div>
                        <div className="d-flex-center product-highlight-row">
                          <span className="muted-span-1">
                            {translation
                              .Products_customer_profit[
                              lang
                            ]
                              ? translation
                                .Products_customer_profit[
                              lang
                              ]
                              : "سود مشتری"}
                            :
                          </span>
                          <span className="muted-span-2 product-highlight-value">
                            {formatCustomerProfitPercent(
                              item.customer_profit_percent
                            )}
                          </span>
                        </div>
                        <div className="d-flex-center product-unit-row product-highlight-row">
                          <span className="muted-span-1">
                            {translation
                              .Products_Quantity[
                              lang
                            ]
                              ? translation
                                .Products_Quantity[
                              lang
                              ]
                              : "تعداد در واحد"}
                            :
                          </span>
                          <span className="muted-span-2 product-unit-count product-highlight-value">
                            {item.unit_count}
                          </span>
                          {unitOptions.length > 1 ? (
                            <ProductUnitSelect
                              options={unitOptions}
                              value={item.selectedUnitLevel}
                              onChange={(unitLevel) => unitChangeHandler(item, unitLevel)}
                            />
                          ) : (
                            <span className="muted-span-2 product-highlight-value">
                              {item.measure_unit?.name}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="gift"
                        onClick={() => {
                          setGift(item.Gifts);
                          setShowGiftModal(true);
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.9775 7.5H2.97754V13.5C2.97754 15.75 3.72754 16.5 5.97754 16.5H11.9775C14.2275 16.5 14.9775 15.75 14.9775 13.5V7.5Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M16.125 5.25V6C16.125 6.825 15.7275 7.5 14.625 7.5H3.375C2.2275 7.5 1.875 6.825 1.875 6V5.25C1.875 4.425 2.2275 3.75 3.375 3.75H14.625C15.7275 3.75 16.125 4.425 16.125 5.25Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            opacity="0.4"
                            d="M8.73008 3.75008H4.59008C4.33508 3.47258 4.34258 3.04508 4.61258 2.77508L5.67758 1.71008C5.95508 1.43258 6.41258 1.43258 6.69008 1.71008L8.73008 3.75008Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            opacity="0.4"
                            d="M13.4025 3.75008H9.26245L11.3025 1.71008C11.58 1.43258 12.0375 1.43258 12.315 1.71008L13.38 2.77508C13.65 3.04508 13.6575 3.47258 13.4025 3.75008Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            opacity="0.4"
                            d="M6.70508 7.5V11.355C6.70508 11.955 7.36508 12.3075 7.86758 11.985L8.57258 11.52C8.82758 11.355 9.15008 11.355 9.39758 11.52L10.0651 11.97C10.5601 12.3 11.2276 11.9475 11.2276 11.3475V7.5H6.70508Z"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="row-2">
                      <div className="count">
                        <button
                          className="count-btn plus"
                          aria-label="Increase by one"
                          onClick={() =>
                            increaseHandler(item)
                          }
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 1L7.5 14"
                              stroke="#0085FF"
                              strokeLinecap="round"
                            />
                            <path
                              d="M14 7.5L1 7.5"
                              stroke="#0085FF"
                              strokeLinecap="round"
                            />
                          </svg>
                        </button>
                        <ProductQuantityInput
                          value={item.num}
                          onCommit={(nextCount) =>
                            countChangeHandler(item, nextCount)
                          }
                        />
                        <button
                          onClick={() =>
                            item.num > 0 &&
                            decreaseHandler(item)
                          }
                          className="count-btn"
                          aria-label="Decrease by one"
                        >
                          <svg
                            width="15"
                            height="1"
                            viewBox="0 0 15 1"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14 0.5L1 0.5"
                              stroke="#0085FF"
                              strokeLinecap="round"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="inventory">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.9999 4.58325L6.92992 1.83325L1.83325 5.49992L5.90325 8.24992L10.9999 4.58325Z"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M11 4.58325L15.07 1.83325L20.1667 5.49992L16.0967 8.24992L11 4.58325Z"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10.9999 12.8334L6.92992 15.5834L1.83325 11.9167L5.90325 9.16675L10.9999 12.8334Z"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M11 12.8334L15.07 15.5834L20.1667 11.9167L16.0967 9.16675L11 12.8334Z"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            opacity="0.4"
                            d="M17.4166 14.2083V17.2057L11.3849 19.9924C11.1374 20.1024 10.8624 20.1024 10.6149 19.9924L4.58325 17.2057V14.2083"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>
                          {translation
                            .Products_inventory[
                            lang
                          ]
                            ? translation
                              .Products_inventory[
                            lang
                            ]
                            : "موجودی"}
                          :
                        </span>
                        <span className="inv-num">
                          {item.inventory}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex-center pro-row">
                      <div className="d-flex-center">
                        <div className="price-blue min-w-160">
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g opacity="0.4">
                              <path
                                d="M7.4375 12.4688C7.4375 14.1487 8.82 15.5312 10.5 15.5312C12.18 15.5312 13.5625 14.1487 13.5625 12.4688"
                                stroke="#0085FF"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.70827 1.75L4.54077 4.92625"
                                stroke="#0085FF"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M13.2908 1.75L16.4583 4.92625"
                                stroke="#0085FF"
                                strokeWidth="1.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </g>
                            <path
                              d="M1.75 6.86865C1.75 5.2499 2.61625 5.11865 3.6925 5.11865H17.3075C18.3838 5.11865 19.25 5.2499 19.25 6.86865C19.25 8.7499 18.3838 8.61865 17.3075 8.61865H3.6925C2.61625 8.61865 1.75 8.7499 1.75 6.86865Z"
                              stroke="#0085FF"
                              strokeWidth="1.5"
                            />
                            <path
                              d="M3.0625 8.75L4.29625 16.31C4.57625 18.0075 5.25 19.25 7.7525 19.25H13.0288C15.75 19.25 16.1525 18.06 16.4675 16.415L17.9375 8.75"
                              stroke="#0085FF"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                            />
                          </svg>
                          <span className="price-n">
                            {Number(
                              item.unit_price *
                              item.num
                            ).toLocaleString()}
                          </span>
                          <span>
                            {currency && currency}
                          </span>
                        </div>
                        {item.discount_percent
                          ? item.discount_percent !==
                          0 && (
                            <span className="discount">
                              {
                                item.discount_percent
                              }
                              %
                            </span>
                          )
                          : ""}
                      </div>
                      <svg
                        className="mt-10"
                        width="48"
                        height="28"
                        viewBox="0 0 48 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="48"
                          height="28"
                          rx="14"
                          fill="#CCEDFF"
                        />
                        <path
                          d="M28.96 8.16992C30.96 9.55992 32.34 11.7699 32.62 14.3199"
                          stroke="#3BA7E4"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.49 14.37C15.75 11.83 17.11 9.61997 19.09 8.21997"
                          stroke="#3BA7E4"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M20.1899 22.9399C21.3499 23.5299 22.6699 23.8599 24.0599 23.8599C25.3999 23.8599 26.6599 23.5599 27.7899 23.0099"
                          stroke="#3BA7E4"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21.28 6.91989C21.28 8.44989 22.52 9.69989 24.06 9.69989C25.6 9.69989 26.84 8.45989 26.84 6.91989C26.84 5.37989 25.6 4.13989 24.06 4.13989"
                          stroke="#3BA7E4"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M16.83 21.9201C18.3654 21.9201 19.61 20.6755 19.61 19.1401C19.61 17.6048 18.3654 16.3601 16.83 16.3601C15.2947 16.3601 14.05 17.6048 14.05 19.1401C14.05 20.6755 15.2947 21.9201 16.83 21.9201Z"
                          stroke="#3BA7E4"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M33.9399 19.1401C33.9399 17.6101 32.6999 16.3601 31.1599 16.3601C29.6199 16.3601 28.3799 17.6001 28.3799 19.1401C28.3799 20.6801 29.6199 21.9201 31.1599 21.9201"
                          stroke="#3BA7E4"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    {item.description && (
                      <div className="info-div">
                        <svg
                          onClick={() => {
                            setDescription(
                              item.description
                            );
                            setShowDescription(
                              true
                            );
                          }}
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.4999 22.9166C18.2291 22.9166 22.9166 18.2291 22.9166 12.4999C22.9166 6.77075 18.2291 2.08325 12.4999 2.08325C6.77075 2.08325 2.08325 6.77075 2.08325 12.4999C2.08325 18.2291 6.77075 22.9166 12.4999 22.9166Z"
                            stroke="#FF9A51"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            opacity="0.6"
                            d="M12.5 8.33325V13.5416"
                            stroke="#FF9A51"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            opacity="0.6"
                            d="M12.4944 16.6667H12.5037"
                            stroke="#FF9A51"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                );
              })}
          </InfiniteScroll>

          <div className=" mt-4"></div>
          <CreditCartPreviewBar
            shopId={shopId}
            cartTotal={allAmount}
            existingOrderTotal={baseNewOrderTotal}
            currency={currency}
          />
          {cartLoading ? (
            <CartBarSkeleton />
          ) : (
            <div onClick={addToCartHandler} className="add-to-cart">
              {translation.Products_Add[lang]
                ? translation.Products_Add[lang]
                : "افزودن به سبد خرید"}
            </div>
          )}
        </div>
      ) : (
        <div className="emp-main">
          <svg
            width="145"
            height="145"
            viewBox="0 0 145 145"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M50.8847 124.568C61.4915 130.134 66.7949 132.917 72.5 132.917V72.5006L15.9381 42.7312C15.8548 42.8651 15.773 43.0002 15.6927 43.1367C12.0834 49.2659 12.0834 56.893 12.0834 72.1472V72.854C12.0834 88.108 12.0834 95.7356 15.6927 101.865C19.3019 107.994 25.8018 111.405 38.8014 118.227L50.8847 124.568Z"
              fill="#3BA7E4"
            />
            <path
              opacity="0.7"
              d="M106.197 26.7737L94.1135 20.4327C83.5068 14.8665 78.2034 12.0833 72.4982 12.0833C66.7931 12.0833 61.4897 14.8665 50.8828 20.4327L38.7995 26.7737C26.0892 33.4437 19.5926 36.8531 15.9362 42.7305L72.4982 72.5L129.06 42.7305C125.403 36.8531 118.907 33.4437 106.197 26.7737Z"
              fill="#3BA7E4"
            />
            <path
              opacity="0.5"
              d="M129.307 43.1367C129.227 43.0002 129.145 42.8651 129.062 42.7312L72.5 72.5006V132.917C78.2051 132.917 83.5085 130.134 94.1153 124.568L106.199 118.227C119.198 111.405 125.698 107.994 129.307 101.865C132.917 95.7356 132.917 88.108 132.917 72.854V72.1472C132.917 56.893 132.917 49.2659 129.307 43.1367Z"
              fill="#3BA7E4"
            />
            <path
              d="M38.2036 27.0897C38.4019 26.9856 38.6018 26.8807 38.8033 26.7749L47.8267 22.0397L102.81 52.2808L127.12 40.1258C127.952 41.0679 128.675 42.0605 129.309 43.1371C130.213 44.6718 130.89 46.3004 131.398 48.1191L107.241 60.1975V78.5429C107.241 81.0453 105.213 83.0741 102.71 83.0741C100.208 83.0741 98.1789 81.0453 98.1789 78.5429V64.7286L77.0331 75.3015V132.338C75.481 132.725 74.0056 132.918 72.5019 132.918C70.9987 132.918 69.5227 132.725 67.9706 132.338V75.3015L13.6056 48.1191C14.1135 46.3004 14.7908 44.6718 15.6946 43.1371C16.3285 42.0605 17.0516 41.0679 17.8835 40.1258L72.5019 67.4352L92.9602 57.2059L38.2036 27.0897Z"
              fill="#3BA7E4"
            />
            <path
              d="M126.869 95.7335C126.265 95.0689 125.6 94.404 124.875 93.8602C120.646 90.1748 115.208 88 109.167 88C104.877 88 100.829 89.148 97.3249 91.1418C96.177 91.746 95.0896 92.4709 94.0625 93.3167C88.5042 97.7271 85 104.554 85 112.167C85 116.698 86.2689 120.987 88.5043 124.612C89.048 125.579 89.7126 126.485 90.4376 127.331C90.5585 127.513 90.7394 127.633 90.8602 127.815C95.2102 133.011 101.796 136.333 109.167 136.333C115.269 136.333 120.827 134.098 125.056 130.292C125.298 130.11 125.479 129.929 125.66 129.688C127.292 128.298 128.681 126.546 129.829 124.612C132.064 120.987 133.333 116.698 133.333 112.167C133.333 105.823 130.856 100.084 126.869 95.7335ZM118.229 116.577H113.698V121.29C113.698 123.767 111.644 125.821 109.167 125.821C106.69 125.821 104.635 123.767 104.635 121.29V116.577H100.104C97.6271 116.577 95.5729 114.523 95.5729 112.046C95.5729 109.569 97.6271 107.514 100.104 107.514H104.635V103.225C104.635 100.748 106.69 98.6939 109.167 98.6939C111.644 98.6939 113.698 100.748 113.698 103.225V107.514H118.229C120.706 107.514 122.76 109.569 122.76 112.046C122.76 114.523 120.706 116.577 118.229 116.577Z"
              fill="#3BA7E4"
            />
          </svg>

          <p className="emp-text">
            {translation.toast_error023[lang]
              ? translation.toast_error023[lang]
              : "کالایی ثبت نشده است."}
          </p>
        </div>
      )}
    </div>
  );
};

export default ShopProducts;
